import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, setLastRoute, addBreadcrumb } from './appInsights';
import { scheduleWhiteScreenCheck, cancelScheduledWhiteScreenCheck } from './whiteScreenDetector';

const RouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const fullUrl = window.location.href;

    // trackPageView sanitiza a URL internamente removendo query strings
    trackPageView(path, fullUrl);

    setLastRoute(path);
    addBreadcrumb({ flow: 'navigation', message: path });

    // Agenda verificação de ecrã em branco (com debounce de 3.5s)
    scheduleWhiteScreenCheck(path);

    return () => {
      cancelScheduledWhiteScreenCheck();
    };
  }, [location]);

  return null;
};

export default RouteTracker;
